const DB_NAME = 'salon-side-capture-store';
const STORE_NAME = 'captures';

function normalizeSessionId(sessionId) {
  if (sessionId == null) return null;
  const value = String(sessionId).trim();
  return value || null;
}

function openStore() {
  if (typeof window === 'undefined' || !window.indexedDB) {
    return Promise.resolve(null);
  }

  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open(DB_NAME, 1);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'sessionId' });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function saveSideCaptures(sessionId, captures) {
  const sid = normalizeSessionId(sessionId);
  const hasCaptures = Boolean(captures && typeof captures === 'object' && (captures.left || captures.right));
  if (!sid || !hasCaptures) return;

  const db = await openStore();
  if (!db) return;

  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    store.put({ sessionId: sid, captures: { left: captures.left || null, right: captures.right || null }, ts: Date.now() });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  }).finally(() => db.close());
}

export async function getSideCaptures(sessionId) {
  const sid = normalizeSessionId(sessionId);
  if (!sid) return null;

  const db = await openStore();
  if (!db) return null;

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(sid);
    request.onsuccess = () => {
      const captures = request.result?.captures;
      resolve(captures && (captures.left || captures.right) ? captures : null);
      db.close();
    };
    request.onerror = () => {
      db.close();
      reject(request.error);
    };
  }).catch(() => null);
}